var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"active-section-header__container"},[_c('div',{staticClass:"section__number"},[_vm._v(" "+_vm._s(_vm.sectionNumber))]),_c('div',[_c('div',{staticClass:"section__header"},[_vm._v(" "+_vm._s(_vm.sectionHeader)+" ")]),_c('div',{staticClass:"section__sub-header"},[_vm._v(" "+_vm._s(_vm.sectionSubHeader)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }